<template>
	<div class="about">
		<div class="pg-header">
			<div>
				<label class="title">院中管理统计</label>
			</div>
			<div class="algr">
				<div class="pg-nav">
					<i class="icon-home"></i>
					<span>统计管理</span>|
					<span style="color: #699ce4;">院中管理统计</span>
				</div>
			</div>
		</div>

		<div class="collapse-wrap">
			<div class="search-bar">
				<el-form ref="form" label-width="120px">
					<div class="def-key">
						<label>入院时间
							<el-date-picker size="small" :default-time="['00:00:00', '23:59:59']" style="width:220px"
								type="daterange" align="right" unlink-panels range-separator="至"
								start-placeholder="开始日期" end-placeholder="结束日期" v-model="filter.date"
								:picker-options="pickerOptions" @change="handleFilter(0, $event)"></el-date-picker>
						</label>
						<div style="display: inline-block;">科室
							<el-select size="small" filterable clearable v-model="filter.depId" placeholder="请选择"
								@change="handleFilter(1, $event)">
								<el-option v-for="item in deptList" :key="item.id" :label="item.name"
									:value="item.id"></el-option>
							</el-select>
						</div>
						<div style="display: inline-block;">机构
							<el-select size="small" filterable clearable v-model="filter.orgId" placeholder="请选择"
								@change="handleFilter(1, $event)">
								<el-option v-for="item in orgList" :key="item.id" :label="item.name"
									:value="item.id"></el-option>
							</el-select>
						</div>
						<el-button size="mini" icon="el-icon-search" round @click="handleFilter">搜索</el-button>
						<el-button v-if="permission" class="btn-export flr" size="mini" round @click="exportReport"><i class="icon-export" style="margin-right: 10px;"></i>导出</el-button>
					</div>
				</el-form>
			</div>
			<div class="table-wrap">
				<el-table ref="multipleTable" header-cell-class-name="tab-cell" cell-class-name="tab-cell" border
					show-summary :summary-method="getSummaries" :data="list.data" v-loading="isLoading"
					@selection-change="selectionChange">
					<el-table-column prop="depName" label="科室" width="180"></el-table-column>
					<el-table-column prop="countId" label="入院人次"></el-table-column>
					<CustomTableColumn prop="waitingAllocated" label="待管理人次" routeName="Hospital/Common" datasources="3" :extraQueryParams="{ date: filter.date,status:1}"></CustomTableColumn>
					<CustomTableColumn prop="finishAllocated" label="管理中人次" routeName="Hospital/Common" datasources="3" :extraQueryParams="{ date: filter.date,status:2}"></CustomTableColumn>
					<CustomTableColumn prop="doneAllocated" label="已完成人次" routeName="Hospital/Common" datasources="3" :extraQueryParams="{ date: filter.date,status:3}"></CustomTableColumn>
					<CustomTableColumn prop="donotAllocated" label="勿访人次" routeName="Hospital/Common" datasources="3" :extraQueryParams="{ date: filter.date,status:5}"></CustomTableColumn>
					<CustomTableColumn prop="unManagedAllocated" label="已过期人次" routeName="Hospital/Common" datasources="3" :extraQueryParams="{ date: filter.date,status:4}"></CustomTableColumn>
					<el-table-column>
						<template slot="header">
							管理率
							<img @click="openModal('header')" class="t-img" src="../../assets/images/question-fill.png" alt="">
						</template>
						<template slot-scope="scope">
							<span>{{ scope.row.managementRate}}</span>
							<img  @click="openModal('column',scope.row)" class="t-img" src="../../assets/images/question-fill.png" alt="">
						</template>
					</el-table-column>
					<el-table-column label="已评估人次">
						<template slot-scope="scope"><span class="fc key"
								@click="handleEve(scope.row.depId,'Evaluated')">{{ scope.row.countEvaluators}}</span></template>
					</el-table-column>
					<el-table-column prop="evaluatorsRate" label="评估完成率">
						<template slot="header">
							评估完成率
							<img @click="openModal('header1')" class="t-img" src="../../assets/images/question-fill.png" alt="">
						</template>
						<template slot-scope="scope">
							<span>{{ scope.row.evaluatorsRate}}</span>
							<img  @click="openModal('column1',scope.row)" class="t-img" src="../../assets/images/question-fill.png" alt="">
						</template>
					</el-table-column>
					<el-table-column label="处方生成人次" >
						<template slot-scope="scope"><span class="fc key"
								@click="handleEve(scope.row.depId,'Prescription')">{{ scope.row.countPrescription}}</span></template>
					</el-table-column>
					<el-table-column prop="prescriptionRate" label="处方生成率">
						<template slot="header">
							处方生成率
							<img @click="openModal('header2')" class="t-img" src="../../assets/images/question-fill.png" alt="">
						</template>
						<template slot-scope="scope">
							<span>{{ scope.row.prescriptionRate}}</span>
							<img  @click="openModal('column2',scope.row)" class="t-img" src="../../assets/images/question-fill.png" alt="">
						</template>
					</el-table-column>
					<el-table-column label="用药处方">
						<el-table-column prop="medication" label="人次"></el-table-column>
						<el-table-column prop="medicationRate" label="占比">
							<template slot="header">
								占比
								<img @click="openModal('header3')" class="t-img" src="../../assets/images/question-fill.png" alt="">
							</template>
						</el-table-column>
					</el-table-column>
					<el-table-column label="饮食处方">
						<el-table-column prop="food" label="人次"></el-table-column>
						<el-table-column prop="foodRate" label="占比">
							<template slot="header">
								占比
								<img @click="openModal('header3')" class="t-img" src="../../assets/images/question-fill.png" alt="">
							</template>
						</el-table-column>
					</el-table-column>
					<el-table-column label="运动处方">
						<el-table-column prop="sports" label="人次"></el-table-column>
						<el-table-column prop="sportsRate" label="占比">
							<template slot="header">
								占比
								<img @click="openModal('header3')" class="t-img" src="../../assets/images/question-fill.png" alt="">
							</template>
						</el-table-column>
					</el-table-column>
					<el-table-column label="心理处方">
						<el-table-column prop="psychology" label="人次"></el-table-column>
						<el-table-column prop="psychologyRate" label="占比">
							<template slot="header">
								占比
								<img @click="openModal('header3')" class="t-img" src="../../assets/images/question-fill.png" alt="">
							</template>
						</el-table-column>
					</el-table-column>
					<el-table-column label="睡眠处方">
						<el-table-column prop="sleep" label="人次"></el-table-column>
						<el-table-column prop="sleepRate" label="占比">
							<template slot="header">
								占比
								<img @click="openModal('header3')" class="t-img" src="../../assets/images/question-fill.png" alt="">
							</template>
						</el-table-column>
					</el-table-column>
					<el-table-column label="中医处方">
						<el-table-column prop="chineseMedicine" label="人次"></el-table-column>
						<el-table-column prop="chineseMedicineRate" label="占比">
							<template slot="header">
								占比
								<img @click="openModal('header3')" class="t-img" src="../../assets/images/question-fill.png" alt="">
							</template>
						</el-table-column>
					</el-table-column>
					<!-- 
					<el-table-column label="已开具处方占比">
						<template slot="header">
							已开具处方占比
							<img @click="openModal('header3')" class="t-img" src="../../assets/images/question-fill.png" alt="">
						</template>
						<el-table-column prop="medicationRate" label="用药"></el-table-column>
						<el-table-column prop="foodRate" label="饮食"></el-table-column>
						<el-table-column prop="sportsRate" label="运动"></el-table-column>
						<el-table-column prop="psychologyRate" label="心理"></el-table-column>
						<el-table-column prop="sleepRate" label="睡眠"></el-table-column>
						<el-table-column prop="chineseMedicineRate" label="中医"></el-table-column>
					</el-table-column> -->
				</el-table>
				<div class="pagination">
					<el-row>
						<el-col :span="12">
							<div class="record">当前是第<span
									v-text="(filter.pageNumber-1)*filter.pageSize+1"></span>条至第<span
									v-text="(filter.pageNumber-1)*filter.pageSize+filter.pageSize"></span>数据</div>
							<div class="record">总计<span v-text="list.total"></span>条记录</div>
						</el-col>
						<el-col :span="12" style="text-align: right;">
							<el-pagination :disabled="isLoading" layout="sizes, prev, pager, next"
								:page-sizes="[10, 20, 30, 40, 50, 60, 70, 80, 90, 100]" prev-text="上一页" next-text="下一页"
								:current-page="list.current" :page-size="filter.pageSize" :total="list.total"
								@size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
						</el-col>
					</el-row>
				</div>
			</div>

		</div>
		<ModalCommon :dlg.sync="dlg" v-if="dlg.visible" />

	</div>
</template>

<script>
	import api from '@/service/api.js';
	import mixin from '@/views/mixin';
	import dayjs from 'dayjs';

	import ModalCommon from './components/modalCommon.vue';
	import questionFillImg from '@/assets/images/question-fill.png';
	import CustomTableColumn from './components/tableColumn.vue';

	export default {
		mixins: [mixin],
		components:{ModalCommon,CustomTableColumn},
		data() {
			return {
				list: {
					current: 1,
					total: 0,
					pageSize: 0,
					data: null,
					summary: []
				},
				filter: {
					inHospitalDataStart: '',
					inHospitalDataEnd: '',
					depId: '',
					orgId:'',
					pageNumber: 1,
					pageSize: 10,
					date:[]
				},
				deptList: [],
				permission: false,
				orgList:[],
				dlg:{
					visible:false,
					type:'',
					propname:'hospitalIn',
					data:{},
				},
			}
		},
		created() {
			// 获取 科室下拉
			api.getDeptDropdown({
				departmentType: 0
			}).then((res) => {
				if (res.code == 1000 && res.data) {
					this.deptList = res.data;
				}
			})
			// 获取机构下拉
			api.getListComboboxOrg().then((res)=>{
				if(res.code==1000){
					this.orgList=res.data;
				} else {
					this.$message.error(res.message)
				}
			})
			
		},
		mounted(){
			const now = dayjs();
			const firstDayOfMonth = dayjs().startOf('month');
			this.filter.inHospitalDataStart = firstDayOfMonth.format('YYYY-MM-DD HH:mm:ss');
			this.filter.inHospitalDataEnd=now.format('YYYY-MM-DD HH:mm:ss');
			this.filter.date=[this.filter.inHospitalDataStart,this.filter.inHospitalDataEnd];
			this.loadList();
		},
		methods: {
			async loadList() {
			console.log(this.filter.date,'[===========this.filter.date]')

				this.isLoading = true;
				let res = await api.getInHospitalManagerReport(this.filter);
				if (res.code == 500) {
					return this.$router.push({
						name: 'Login',
						query: {
							r: location.href
						}
					});
				}

				this.list.total = +res.total;
				this.list.current = this.filter.pageNumber;
				this.list.pageSize = Math.ceil(this.list.total / this.filter.pageSize);
				if (res.code == 1000 && res.data) {
					this.list.summary = ['合计', res.data.sum.sum.countId, res.data.sum.sum.waitingAllocated, res.data
						.sum.sum.finishAllocated, res.data.sum.sum.doneAllocated, res.data.sum.sum.donotAllocated,
						res.data.sum.sum.unManagedAllocated, res.data.sum.sum.managementRate, res.data.sum.sum
						.countEvaluators, res.data.sum.sum.evaluatorsRate, res.data.sum.sum.countPrescription, res
						.data.sum.sum.prescriptionRate,res
						.data.sum.sum.medication,res
						.data.sum.sum.medicationRate,res
						.data.sum.sum.food,res
						.data.sum.sum.foodRate,res
						.data.sum.sum.sports,res
						.data.sum.sum.sportsRate,res
						.data.sum.sum.psychology,res
						.data.sum.sum.psychologyRate,res
						.data.sum.sum.sleep,res
						.data.sum.sum.sleepRate,res
						.data.sum.sum.chineseMedicine,res
						.data.sum.sum.chineseMedicineRate
					];
					this.list.data = res.data.list.list;
				}
				// 权限控制
				this.user = JSON.parse(localStorage.getItem('user')).data;
				this.permission = (this.user.user.roleId == "6" || this.user.user.roleId == "1") ? true : false;
				this.isLoading = false;
			},
			getSummaries() {
				if (this.$refs['multipleTable']) {
					let current = this.$refs['multipleTable']
					let tbodyElement = current.$el.querySelector('tbody.has-gutter');
					if (tbodyElement) {
						let trElements = tbodyElement.querySelectorAll('tr');
						let img1 = document.querySelector('.img1');
						let img2 = document.querySelector('.img2');
						let img3 = document.querySelector('.img3');

						trElements.forEach(tr => {
							let tdElements = tr.querySelectorAll('td');
							tdElements.forEach((td, index) => {
								let divElement = td.querySelector('.cell');

								if (divElement && !(img1 || img2) && (index == 7 ||index == 9 || index == 11)) {
									let imgElement = document.createElement('img');
									imgElement.src = questionFillImg;

									if (index == 7) {
										imgElement.className = 'img1';
										imgElement.addEventListener('click', () =>this.openSumModal('column'));
									} else if (index == 9) {
										imgElement.className = 'img2';
										imgElement.addEventListener('click', () =>this.openSumModal('column1'));
									} else if (index == 11) {
										imgElement.className = 'img3';
										imgElement.addEventListener('click', () =>this.openSumModal('column2'));
									}
									divElement.appendChild(imgElement);
								}
							});

						});
					} else {
						console.error('无法找到<tbody>元素！');
					}
				}
				this.$nextTick(() => {
					this.$refs['multipleTable'].doLayout();
				});
				return this.list.summary;
			},
			openSumModal(type){
				this.dlg.type=type;
				if(type=='column'){
					this.dlg.data.managementRate=this.list.summary[7]
					this.dlg.data.finishAllocated=this.list.summary[3]
					this.dlg.data.doneAllocated=this.list.summary[4]
					this.dlg.data.countId=this.list.summary[1]
				}else if(type=='column1'){
					this.dlg.data.evaluatorsRate=this.list.summary[9]
					this.dlg.data.countEvaluators=this.list.summary[8]
					this.dlg.data.finishAllocated=this.list.summary[3]
					this.dlg.data.doneAllocated=this.list.summary[4]
				}else if(type=='column2'){
					this.dlg.data.prescriptionRate=this.list.summary[11]
					this.dlg.data.countPrescription=this.list.summary[10]
					this.dlg.data.finishAllocated=this.list.summary[3]
					this.dlg.data.doneAllocated=this.list.summary[4]
				}
				this.dlg.visible = true;
			},
			// 过滤条件 更改
			handleFilter(key, val) {
				switch (key) {
					case 0:
						console.log(this.filter.date,'=============this.filter.inHospitalDataEnd')
						if (this.filter.date) {
							this.filter.inHospitalDataStart = dayjs(this.filter.date[0]).format('YYYY-MM-DD 00:00:00');
							this.filter.inHospitalDataEnd = dayjs(this.filter.date[1]).format('YYYY-MM-DD 23:59:59');
						} else {
							this.filter.inHospitalDataStart = '';
							this.filter.inHospitalDataEnd = '';
						}
						break;
				}
				this.filter.pageNumber = 1;
				this.loadList();
			},
			handleSizeChange(v) {
				this.filter.pageSize = v;
				this.filter.pageNumber = 1;
				this.loadList();
			},
			handleCurrentChange(v) {
				this.filter.pageNumber = v;
				this.loadList();
			},
			exportReport() {
				this.filter.pageSize=this.list.total;
				let url = api.exportStatisticManagerReport(this.filter);
				const tempLink = document.createElement('a');
				tempLink.style.display = 'none';
				tempLink.href = url;
				tempLink.target = '_blank';
				document.body.appendChild(tempLink);
				tempLink.click()
				document.body.removeChild(tempLink);
			this.filter.pageSize=10;

			},
			handleEve(depId, type) {
				// console.log(item,'------------ii');
				let dateStart = this.filter.inHospitalDataStart ? dayjs(this.filter.inHospitalDataStart).format(
					'YYYY-MM-DD') : '';
				let dateEnd = this.filter.inHospitalDataEnd ? dayjs(this.filter.inHospitalDataEnd).format('YYYY-MM-DD') :
					'';
				window.open(`#/statistics/${type}?depId=${depId}&dateStart=${dateStart}&dateEnd=${dateEnd}`, "_blank")
			},
			openModal(type,data){
				this.dlg.data = data;
				this.dlg.type = type;
				this.dlg.visible = true;
			}
		}
	}
</script>

<style lang="less" scoped>
	@import '@/assets/style/var';
	@import './components/sty.less';

	.fc {
		cursor: pointer;
	}
</style>